import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CryptoService } from './Encryption';

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {


  constructor(private encryptionService: CryptoService) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
      const apiPathsToApplyDescription: string[] = ['api/'];
      const shouldApplyDescription = apiPathsToApplyDescription.some(path => request.url.includes(path));

      if(shouldApplyDescription){
      const encryptedRequest = this.encryptRequest(request);

      const requestWithResponseType = encryptedRequest.clone({
        responseType: 'text',
      });

      return next.handle(requestWithResponseType).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const decryptedResponse = this.decryptResponse(event);
            console.log('Decrypted Response:', decryptedResponse);

            return new HttpResponse({
              body: decryptedResponse,
              headers: event.headers,
              status: event.status,
              statusText: event.statusText,
              // url: event.url,
              // Add any other necessary properties
            });
          }
          return event;
        }),
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            const decryptedError = this.decryptErrorResponse(error);
            console.error('Decrypted Error:', decryptedError);
            throw decryptedError;
          }
          return throwError(error);
        })
      );
      }else{
      return next.handle(request);
      }
  }

  private encryptRequest(request: HttpRequest<any>): HttpRequest<any> {
    if (request.body) {
      try {
        const encryptedBody = this.encryptionService.encrypt(request.body);
        return request.clone({
          body: encryptedBody,
        });
      } catch (encryptionError) {
        console.error('Encryption failed:', encryptionError);
        return request;
      }
    }

    return request;
  }

  private decryptResponse(response: HttpResponse<any>): any {
    if (typeof response.body === 'string') {
      try {
        
        const decryptedResponse = this.encryptionService.decrypt(response.body);
  
        if (this.isValidJson(decryptedResponse)) {
          return JSON.parse(decryptedResponse);
        } else {
          console.warn('Decrypted response is not valid JSON:', decryptedResponse);
          return decryptedResponse;
        }
      } catch (decryptionError) {
        console.error('Error decrypting response:', decryptionError);
        throw decryptionError;
      }
    } else {
      return response.body;
    }
  }
  
  private isValidJson(data: string): boolean {
    try {
      JSON.parse(data);
      return true;
    } catch (error) {
      return false;
    }
  }
  
  

  private decryptErrorResponse(error: HttpErrorResponse): HttpErrorResponse {
    if (typeof error.error === 'string') {
      try {
        const decryptedErrorBody = this.encryptionService.decrypt(error.error);
        return new HttpErrorResponse({
          error: decryptedErrorBody,
          headers: error.headers,
          status: error.status,
          statusText: error.statusText,
          url: error.url || undefined,
        });
      } catch (decryptionError) {
        console.error('Error decrypting error response:', decryptionError);
        return error;
      }
    } else {
      return error;
    }
  }
}
